'use client';

import { Download01, Pencil02 } from '@ethsign/icons';

import { Button } from '@ethsign/ui';

import { LogoIcon } from '@/components/Icons';
import { useRouter } from '@/hooks';

type Props = {
  isShowDownload?: boolean;
  onDownload?: () => void;
  id: string;
};
export const Header = (props: Props) => {
  const { isShowDownload = true, onDownload, id } = props;
  const router = useRouter();
  return (
    <div className="absolute flex bg-white h-[72px] w-full flex-row items-center px-10  justify-between border-b border-b-gray-100 text-lg font-medium text-gray-700">
      <div
        className="cursor-pointer"
        onClick={() => {
          router.push('/dashboard');
        }}
      >
        <LogoIcon />
      </div>
      <div className="flex flex-row items-center">
        <Button
          variant="outline"
          className="flex flex-row items-center cursor-pointer mr-4"
          onClick={() => {
            window.location.href = `/contract/${id}`;
          }}
        >
          <Pencil02 size={20} color="#344054" />
          <span className="ml-2">Sign</span>
        </Button>
        {isShowDownload && (
          <Button variant="outline" className="flex flex-row items-center cursor-pointer" onClick={onDownload}>
            <Download01 size={20} color="#344054" />
            <span className="ml-2">Download</span>
          </Button>
        )}
      </div>
    </div>
  );
};
